import { _ } from "../../core/polyglot/polyglot.js";
import AbstractDeviationType from "./AbstractDeviationType.js";

/**
 * Value Deviation Type expresses the deviation with an absolute value.
 */
export default class ValueDeviationType extends AbstractDeviationType {
	getLabel() {
		return _("Value");
	}

	makeDeviationColumnTemplate(spec) {
		return this._makeDeviationColumnTemplate({
			...spec,
			inPercent: false,
		});
	}

	static getType() {
		return "ValueDeviationType";
	}
}
